import { Dispatch, SetStateAction, useEffect, useState } from "react";
import { contentMenuList, emptyMenuPage, MenuContentPage, typeDailyMenu } from "../../../../components/types/types";
import { FiChevronLeft, FiChevronRight, FiEyeOff } from "react-icons/fi";
import AddPhoto from "../../../../components/addPhoto/addPhoto";
import { stripTime,normalizeDate } from "../hookModifMenu/modifyMenuUtils";
type MenuGroups = [MenuContentPage, MenuContentPage][];
export const getMenuAndStyle = (menu:contentMenuList): [MenuGroups | null, React.CSSProperties | null] => {
    if(!menu.menu) return [null,null]
    let menuUse = menu.menu
    if(!menuUse.length || menuUse.length === 0) {
        return [[[emptyMenuPage,emptyMenuPage],[emptyMenuPage, emptyMenuPage]],null]
    }
    else {
        let newGroups:[MenuContentPage,MenuContentPage][] = [[emptyMenuPage,menuUse[0]]]
        let isImgBack = null
        let isColorBack = ''
        let styleBorder:React.CSSProperties|null = null
        if(menuUse[0].imgback) {
            isImgBack = menuUse[0].imgback
        }
        if(menuUse[0].colorback) {
            isColorBack = menuUse[0].colorback
        }
        if(menuUse[0].borderpage) {
            const { transparent, color, colorline } = menuUse[0].borderpage;
            const vars: React.CSSProperties = {};

            if (color) {
                (vars as any)['--qr-border-bg-strong'] = color;
                (vars as any)['--qr-border-bg-soft'] = color;
            }
            if (colorline) (vars as any)['--qr-border-line'] = colorline;
            styleBorder = vars;
        }
        const patch = isImgBack ? { imgback: isImgBack } : {};
        const patchColor = isColorBack ? { colorback: isColorBack } : {};
        const patchFont = menuUse[0].fontfamilytext ? { fontfamilytext: menuUse[0].fontfamilytext } : {};
        const patchFontTitle = menuUse[0].fontfamilytitle ? { fontfamilytitle: menuUse[0].fontfamilytitle } : {};
        const patchBorderpage = menuUse[0].borderpage ? { borderpage: menuUse[0].borderpage } : {};
        const front: MenuContentPage = { ...emptyMenuPage, ...patch, ...patchFont,...patchFontTitle,...patchBorderpage,...patchColor };
        const back:  MenuContentPage = { ...emptyMenuPage, ...patch, ...patchFont,...patchFontTitle,...patchBorderpage,...patchColor };
        for(let i = 1; i < menuUse.length; i+=2) {
            let group:[MenuContentPage,MenuContentPage] = [front,back]
            group[0] = menuUse[i]
            if(i + 1 < menuUse.length) {
                group[1] = menuUse[i+1]
            } else if (isImgBack) {
                group[1].imgback = isImgBack;
            }
            newGroups.push(group)
        }
        if(newGroups.length === 1) newGroups = [...newGroups,[front,back]]
        return [newGroups,styleBorder]
    }
}

export const isSameDay = (a: Date, b: Date) =>
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();


const formatShortDate = (date: Date) => {
    return new Intl.DateTimeFormat("fr-FR", {
        day: "2-digit",
        month: "2-digit",
    }).format(date);
};
export const getPeriodDisplay = (menu: contentMenuList,forUser=false) => {
    const start = normalizeDate(menu.period_start);
    const end = normalizeDate(menu.period_end);
    const today = stripTime(new Date());
    if (!start && !end) {
        return {
            hasPeriod: false,
            text: `Mise à jour le ${(menu.date_update ? new Date(menu.date_update): new Date()).toLocaleDateString()}`,
            isHidden: false,
        };
    }
    if (start && !end) {
        const normalizedStart = stripTime(start);
        const isFuture = normalizedStart > today;

        return {
            hasPeriod: true,
            text: forUser
                ? `Depuis le ${formatShortDate(start)}`
                : isFuture
                    ? `Sera visible le ${formatShortDate(start)}`
                    : `Visible à partir du ${formatShortDate(start)}`,
            isHidden: isFuture,
        };
    }
    if (start && end) {
        const normalizedStart = stripTime(start);
        const normalizedEnd = stripTime(end);

        const isFuture = normalizedStart > today;
        const isPast = normalizedEnd < today;
        const isCurrent = !isFuture && !isPast;
        let text;
        if (forUser) {
            text = `Du ${formatShortDate(start)} au ${formatShortDate(end)}`;
        } else {
            if (isFuture) {
                text = `Sera visible du ${formatShortDate(start)} au ${formatShortDate(end)}`;
            } else if (isCurrent) {
                text = `Visible du ${formatShortDate(start)} au ${formatShortDate(end)}`;
            } else {
                text = `Visible du ${formatShortDate(start)} au ${formatShortDate(end)} (non visible)`;
            }
        }

        return {
            hasPeriod: true,
            text,
            isHidden: isFuture || isPast,
        };
    }
    return {
        hasPeriod: false,
        text: `Mise à jour le ${new Date(menu.date_update || '').toLocaleDateString()}`,
        isHidden: false,
    };
};
export const toSqlDate = (value?: Date | string | null): string | null => {
    const d = normalizeDate(value);
    if (!d) return null;

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
};

export const isMenuHiddenByPeriod = (menu: contentMenuList): boolean => {
    const start = normalizeDate(menu.period_start);
    const end = normalizeDate(menu.period_end);
    const today = stripTime(new Date());
    if (!start && !end) return false;
    if (start && !end) return stripTime(start) > today;

    if (start && end) {
        const normalizedStart = stripTime(start);
        const normalizedEnd = stripTime(end);
        return normalizedStart > today || normalizedEnd < today;
    }
    return false;
};
export const isMenuEffectivelyVisible = (menu: contentMenuList): boolean => {
    const hiddenByPeriod = isMenuHiddenByPeriod(menu);
    if (hiddenByPeriod) return false;

    if (menu.isbase) return true;
    return menu.visible ?? false;
};

export const isPdfMenuItem = (item: contentMenuList) => {
    return !!item.link_img_pdf;
};


interface PositionInputProps {
    index: number;
    listLength: number;
    onSubmit: (targetIndex: number) => void;
}
export const PositionInput: React.FC<PositionInputProps> = ({ index, listLength, onSubmit }) => {
    const [value, setValue] = useState(String(index + 1));
    useEffect(() => {
        setValue(String(index + 1));
    }, [index]);
    const commit = () => {
        const raw = value.trim();

        if (raw === "") {
            setValue(String(index + 1));
            return;
        }
        let parsed = Number(raw);
        if (!Number.isFinite(parsed)) {
            setValue(String(index + 1));
            return;
        }
        parsed = Math.trunc(parsed);
        if (parsed <= 0) parsed = 1;
        if (parsed > listLength) parsed = listLength;
        setValue(String(parsed));
        onSubmit(parsed - 1);
    };
    return (
        <input
            className="inputPositionMenu XsmallText"
            value={value}
            inputMode="numeric"
            onClick={(e) => e.stopPropagation()}
            onChange={(e) => {
                e.stopPropagation();
                setValue(e.target.value);
            }}
            onBlur={(e) => {
                e.stopPropagation();
                commit();
            }}
            onKeyDown={(e) => {
                e.stopPropagation();
                if (e.key === "Enter") {
                    e.preventDefault();
                    (e.currentTarget as HTMLInputElement).blur();
                }
            }}
        />
    );
};

export const sanitizeName = (v: string) => v.replace(/\s+/g, " ").trim();

interface DailyMenuListEditProps {
    dailyMenu?:typeDailyMenu,
    id:number,
    activeIndex:number,
    scrollToIndex:(id:number) => void,
    isSelectMenu:boolean,
    selectedIndex:number | null,
    setShowAddMenu:Dispatch<SetStateAction<boolean>>,
    setSelectedIndex:Dispatch<SetStateAction<number | null>>,
    setIsSelectMenu:Dispatch<SetStateAction<boolean>>,
    mergedMenuListLength:number,
    moveMenu:(id:number,target:number) => void,
    canMoveLeft:boolean,
    canMoveRight:boolean,
    swapMenus:(id:number,target:number) => void,
    setFocusedInputIndex:Dispatch<SetStateAction<number | null>>,
    setDailyMenuName:(name:string) => void,
    lastNameOnFocusRef: React.MutableRefObject<string>,
    inputRefs: React.MutableRefObject<(HTMLInputElement | null)[]>,
    handleAddNewDaily:(id:number) => void,
}
export const DailyMenuListEdit:React.FC<DailyMenuListEditProps> = ({dailyMenu,id,activeIndex,isSelectMenu,selectedIndex,lastNameOnFocusRef,inputRefs,canMoveLeft,canMoveRight,mergedMenuListLength,setFocusedInputIndex,setDailyMenuName,moveMenu,setShowAddMenu,setSelectedIndex,setIsSelectMenu,scrollToIndex,swapMenus,handleAddNewDaily}) => {
    const handleClick = () => {
        setShowAddMenu(false);
        setSelectedIndex(id);
        setIsSelectMenu(true);
                                    
        if (id !== activeIndex) {
            scrollToIndex(id);
        }
    }
    let dateUse = dailyMenu ? dailyMenu.dates || ['',''] : ['','']
    const start = normalizeDate(new Date(dateUse[0]));
    const end = normalizeDate(new Date(dateUse[1]));
    const today = stripTime(new Date());
    let periodDisplay = {isHidden:false,text:'Menu'}
    if (start && !end) {
        const normalizedStart = stripTime(start);
        const startTime = normalizedStart.getTime();
         const todayTime = today.getTime()
        const isFuture = normalizedStart > today;
        const isCurrent = startTime === todayTime;
        const isPast = startTime < todayTime;;
        periodDisplay = {
            text: isFuture
                    ? `Sera visible le ${formatShortDate(start)}`
                     : `Visible le ${formatShortDate(start)} ${isCurrent ? '' : '(non visible)'}`,
            isHidden: isFuture || isPast,
        };
    }
    if (start && end) {
        const normalizedStart = stripTime(start);
        const normalizedEnd = stripTime(end);
        const isFuture = normalizedStart > today;
        const isPast = normalizedEnd < today;
        const isCurrent = !isFuture && !isPast;
        let text;
        if (isFuture) {
            text = `Sera visible du ${formatShortDate(start)} au ${formatShortDate(end)}`;
        } else if (isCurrent) {
            text = `Visible du ${formatShortDate(start)} au ${formatShortDate(end)}`;
        } else {
            text = `Visible du ${formatShortDate(start)} au ${formatShortDate(end)} (non visible)`;
        }
        periodDisplay = {
            text,
            isHidden: isFuture || isPast,
        };
    }
    return <><div className={` containerMenu ${(isSelectMenu && id === selectedIndex) ? 'isSelect' : ''} ${(id !== activeIndex) ? 'isNotCenter' : ''} ${id === activeIndex ? 'isCenter' : ''} isForDailyMenu`} onClick={(e) => {e.stopPropagation();handleClick()}}>
        <div className="coverMenu">
            <div className="borderSelection"></div>   
            <div className="contentCover" > 
                <div className="dailyMenu frontImg" style={periodDisplay.isHidden ? {opacity:0.4} : {}}>
                    <img
                        src={dailyMenu?.image || ''}
                        className={`dailyMenu`}
                        loading="lazy"
                        alt="menu du jour"
                        style={{display: 'flex'}}
                    />
                </div>
                <div className="dailyMenuBackLayer" aria-hidden="true" style={periodDisplay.isHidden ? {opacity:0.4} : {}}>
                    <img
                        src={dailyMenu?.image || ''}
                        className="dailyMenu backImg"
                        loading="lazy"
                        alt="menu du jour"
                    />
                </div>
                <div className="maskContent" style={{zIndex:6,backgroundColor:'transparent'}}>
                    <div onClick={(e) => {e.stopPropagation();handleAddNewDaily(id)} } className="longWhiteButton buttonForModify smallText" >
                        Modifier
                    </div>
                </div>
                <div className="maskContent" style={{backgroundColor:'rgba(255,255,255,0.3)',zIndex:2}}></div>
            </div>
        </div>
        <div className="footerPartCover">
            <div className="containerPosition">
                <span className="XsmallText">Position : </span>
                <div className="smallText" style={{...(id !== selectedIndex ? {pointerEvents:'none',cursor:'default'} : {})}}>
                    <FiChevronLeft size={15} className={`pointer lowOpacityHover icon ${!canMoveLeft ? "isDisabled" : ""}`} onClick={(e) => { e.stopPropagation(); if (!canMoveLeft) return; swapMenus(id, id - 1);}}/>
                    <PositionInput index={id} listLength={mergedMenuListLength} onSubmit={(targetIndex) => {
                            if (targetIndex !== id) {
                                moveMenu(id, targetIndex);
                            }
                        }}
                    />
                    <FiChevronRight size={15} className={`pointer lowOpacityHover icon ${!canMoveRight ? "isDisabled" : ""}`} onClick={(e) => { e.stopPropagation(); if (!canMoveRight) return; swapMenus(id, id + 1);}}/>
                </div>
            </div>
            <input
                className={`largeTitle inputTitleMenu inputDaily ${(dailyMenu?.name ?? "").length >= 11 ? 'isLongForDaily' : ''}`}
                value={dailyMenu?.name ?? ""}
                placeholder="Nom..."
                ref={(el) => { inputRefs.current[id] = el; }}
                maxLength={40}
                onFocus={(e) => {
                    e.stopPropagation();
                    lastNameOnFocusRef.current = dailyMenu?.name ?? "";
                    setFocusedInputIndex(id);
                }}
                onChange={(e) => {
                    e.stopPropagation();
                    setDailyMenuName(e.target.value);
                }}
                onBlur={(e) => {
                    e.stopPropagation();
                    const raw = e.target.value ?? "";
                    const trimmed = sanitizeName(raw);

                    if (!trimmed) {
                    const fallback = sanitizeName(lastNameOnFocusRef.current) || "La Carte";
                    setDailyMenuName(fallback);
                    } else {
                    setDailyMenuName(trimmed);
                    }
                    setFocusedInputIndex(prev => prev === id ? null : prev);
                }}
            />
            <i className="dateUpdate XsmallText" >
                {periodDisplay.isHidden && <FiEyeOff size={12} />}
                <span>{periodDisplay.text}</span>
            </i>
            {
                <span className="textInteract smallText" style={{opacity:0}}>Carte interactive</span>
            }
        </div>
    
    </div>
    </>
}
